import React from 'react';
import './diagrams.css';

/* Case 02 hero — the FAST platform at a glance. One hub (the live catalog),
   the surfaces it controls as clusters. The permission model is the accent
   cluster: one platform, many very different users, each scoped. */

const CLUSTERS = [
  { h: 'Collections', meta: 'curated', items: ['Structure & metadata', 'The feels inside', 'Editorial placement in-app'] },
  { h: 'Content', meta: 'catalog', items: ['Song / feel metadata', 'Clip timing — to the ms', 'Hide · lock · unpublish'] },
  { h: 'Artists & labels', meta: 'self-serve', items: ['Artist profiles', 'Sneak Peek content', 'Backdrops (a tool I built)'] },
  { h: 'Permissions', meta: 'roles', items: ['Internal editorial', 'External rights-holders', 'Each sees only what’s theirs'], accent: true },
];

export default function FastArchitecture() {
  return (
    <figure className="ppd">
      <div className="ppd__head">
        <h3 className="ppd__title">One control room, four surfaces, many kinds of user.</h3>
        <span className="ppd__tag">FAST · architecture</span>
      </div>

      <div className="ppd__map">
        <span className="ppd__hub">Live catalog · 100k+ Feels</span>
        <div className="ppd__clusters">
          {CLUSTERS.map((c) => (
            <div key={c.h} className={`ppd__cluster${c.accent ? ' ppd__cluster--accent' : ''}`}>
              <div className="ppd__cluster-h">{c.h}<span>{c.meta}</span></div>
              <ul>
                {c.items.map((it) => <li key={it}>{it}</li>)}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <figcaption className="ppd__caption">
        I own the <b>organization system, the management model, and permissions</b> — so a tiny team and
        outside partners run the same constantly-shifting catalog without stepping on each other.
      </figcaption>
    </figure>
  );
}
